import { z } from 'zod';
import { SpotCategorySchema } from '../spots';
import { AdminPageQuerySchema, adminPage } from './page';

/* Spots */
export const AdminSpotSchema = z.object({
  id: z.string(),
  name: z.string(),
  category: SpotCategorySchema,
  approved: z.boolean(),
  disabled: z.boolean(),
  lat: z.number(),
  lng: z.number(),
  radiusM: z.number().int().positive(),
  createdBy: z.string().nullable(),
  createdAt: z.iso.datetime(),
});
export type AdminSpot = z.infer<typeof AdminSpotSchema>;

export const AdminSpotsQuerySchema = AdminPageQuerySchema.extend({
  filter: z.enum(['all', 'pending', 'disabled']).default('all'),
  q: z.string().max(120).optional(),
});
export type AdminSpotsQuery = z.infer<typeof AdminSpotsQuerySchema>;

export const AdminSpotsResponseSchema = adminPage(AdminSpotSchema);
export type AdminSpotsResponse = z.infer<typeof AdminSpotsResponseSchema>;

export const AdminSpotActionSchema = z.object({
  action: z.enum(['approve', 'reject', 'disable', 'enable', 'set_radius', 'set_category']),
  radiusM: z.number().int().positive().optional(),
  category: SpotCategorySchema.optional(),
  reason: z.string().min(3).max(500),
});
export type AdminSpotAction = z.infer<typeof AdminSpotActionSchema>;
